import { useNotify } from 'react-admin';
import { CopyToClipboard as CopyToClipboardComponent } from 'react-copy-to-clipboard';
import { Tooltip } from '@mui/material';
import { CopyToClipboardProps } from './types';

const CopyToClipboard = ({ children, label, onCopy, tooltipTitle, value }: CopyToClipboardProps) => {
  const notify = useNotify();

  const handleCopy = () => {
    notify(`${label} copied to clipboard`);
    onCopy?.();
  };

  return (
    <CopyToClipboardComponent onCopy={handleCopy} text={value}>
      <Tooltip title={tooltipTitle ?? `Copy ${label}`}>{children}</Tooltip>
    </CopyToClipboardComponent>
  );
};

export default CopyToClipboard;
